// Main JS for Dewan Sons
console.log('Dewan Sons JS initialized');






window.addToCart = function (event) {
    event.preventDefault();

    // Find the button more robustly
    const target = event.target;
    let button = target.closest('button') || target.querySelector('button[type="submit"]');

    const form = target.closest('form');
    if (!form) return;

    const formData = new FormData(form);
    formData.append('sections', 'cart-drawer');

    if (button) {
        button.classList.add('is-loading');
        button.disabled = true;
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
    })
        .then(response => {
            if (!response.ok) {
                return response.text().then(text => {
                    console.error('Shopify Error Response:', text);
                    throw new Error(`Network response was not ok: ${text}`);
                });
            }
            return response.json();
        })
        .then(item => {
            // Refresh drawer content using Section Rendering API
            return fetch(window.location.pathname + '?sections=cart-drawer')
                .then(response => response.json())
                .then(section => {
                    const html = new DOMParser().parseFromString(section['cart-drawer'], 'text/html');
                    const drawerContent = document.getElementById('CartDrawerContent');
                    const newDrawerContent = html.getElementById('CartDrawerContent');

                    if (drawerContent && newDrawerContent) {
                        drawerContent.innerHTML = newDrawerContent.innerHTML;
                    }

                    // Update header count
                    return fetch(window.Shopify.routes.root + 'cart.js')
                        .then(res => res.json())
                        .then(cart => {
                            const count = document.querySelector('[data-cart-count]');
                            if (count) count.textContent = cart.item_count;

                            // Open the drawer
                            if (window.Alpine) {
                                const body = document.querySelector('body');
                                const alpineData = Alpine.$data(body);
                                if (alpineData) {
                                    alpineData.cartOpen = true;
                                }
                            }
                        });
                });
        })
        .catch(error => {
            console.error('Error adding to cart:', error);
            alert('Could not add item to cart. Please try again.');
        })
        .finally(() => {
            if (button) {
                button.classList.remove('is-loading');
                button.disabled = false;
            }
        });
};

window.buyNow = function (event) {
    event.preventDefault();

    // Find the button
    const target = event.target;
    let button = target.closest('button');

    // Selected variant (Shopify standard)
    const variantInput = document.querySelector('input[name="id"]');
    if (!variantInput || !variantInput.value) {
        alert('Please select a variant');
        return;
    }

    const variantId = variantInput.value;

    // Quantity
    const qtyInput = document.querySelector('input[name="quantity"]');
    const quantity = qtyInput ? qtyInput.value : 1;

    if (button) {
        button.classList.add('is-loading');
        button.disabled = true;
    }

    window.location.href = `/cart/${variantId}:${quantity}`;
};

let cartDebounceTimer = null;
const CART_DEBOUNCE_MS = 500;
let currentCartUpdates = {};

window.adjustCart = function (id, delta) {
    const drawer = document.getElementById('CartDrawerContent');
    const targetItem = drawer?.querySelector(`[data-cart-item="${id}"]`);
    if (targetItem) {
        if (delta > 0) {
            const inventoryManagement = targetItem.dataset.inventoryManagement;
            const inventoryPolicy = targetItem.dataset.inventoryPolicy;
            const inventoryQuantity = parseInt(targetItem.dataset.inventoryQuantity || 0);

            const qtyDisplay = targetItem.querySelector('span.w-6, span.w-8, span.w-10');
            const currentQty = qtyDisplay ? parseInt(qtyDisplay.textContent) : 0;
            const newQty = currentQty + delta;

            if (inventoryManagement && inventoryManagement !== 'null' && inventoryPolicy === 'deny' && newQty > inventoryQuantity) {
                const errorMsg = targetItem.querySelector('.cart-item-error');
                if (errorMsg) {
                    errorMsg.textContent = "You can't add more due to limited quantity.";
                    errorMsg.classList.remove('hidden');
                    setTimeout(() => {
                        errorMsg.classList.add('hidden');
                    }, 3000);
                }
                return;
            }
        }

        const qtyDisplay = targetItem.querySelector('span.w-6, span.w-8, span.w-10');
        if (qtyDisplay) {
            const currentQty = parseInt(qtyDisplay.textContent);
            const newQty = Math.max(0, currentQty + delta);
            window.updateCart(id, newQty);
        }
    }
};

window.updateCart = function (id, quantity) {
    console.log('Updating cart: ID', id, 'Quantity', quantity);
    const drawer = document.getElementById('CartDrawerContent');
    if (!drawer) return;

    // 1. Instant Optimistic Update
    const targetItem = drawer.querySelector(`[data-cart-item="${id}"]`);

    if (targetItem) {
        const qtyDisplay = targetItem.querySelector('span.w-6, span.w-8, span.w-10');
        if (qtyDisplay) {
            qtyDisplay.textContent = Math.max(0, quantity);
        }

        // If removing, dim it immediately
        if (quantity === 0) {
            targetItem.style.opacity = '0.3';
            targetItem.style.pointerEvents = 'none';
        }
    }

    // 2. Queue current update
    currentCartUpdates[id] = quantity;

    // 3. Clear existing timer to reset the debounce window
    if (cartDebounceTimer) clearTimeout(cartDebounceTimer);

    // 4. Set new timer for backend sync
    cartDebounceTimer = setTimeout(() => {
        drawer.classList.add('cart-drawer-updating');

        const updates = { ...currentCartUpdates };
        currentCartUpdates = {}; // reset queue

        const body = JSON.stringify({
            updates: updates,
            sections: 'cart-drawer'
        });

        fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body
        })
            .then(response => response.json())
            .then(state => {
                // Update header count first
                const count = document.querySelector('[data-cart-count]');
                if (count) count.textContent = state.item_count;

                // Refresh drawer content explicitly preserving page context
                return fetch(window.location.pathname + '?sections=cart-drawer')
                    .then(response => response.json())
                    .then(section => {
                        const html = new DOMParser().parseFromString(section['cart-drawer'], 'text/html');
                        const newContent = html.getElementById('CartDrawerContent');
                        const currentDrawer = document.getElementById('CartDrawerContent');

                        if (newContent && currentDrawer) {
                            currentDrawer.innerHTML = newContent.innerHTML;
                        }
                    });
            })
            .catch(error => {
                console.error('Error updating cart:', error);
                alert('There was a problem updating your cart. Please try again.');
            })
            .finally(() => {
                const refreshedDrawer = document.getElementById('CartDrawerContent');
                if (refreshedDrawer) {
                    refreshedDrawer.classList.remove('cart-drawer-updating');
                }
            });
    }, CART_DEBOUNCE_MS);
};

// Collection Filters & Search Logic
document.addEventListener('alpine:init', () => {
    Alpine.data('CollectionFilters', () => ({
        loading: false,
        searchQuery: '',
        debounceTimer: null,

        init() {
            const params = new URLSearchParams(window.location.search);
            this.searchQuery = params.get('q') || '';

            window.addEventListener('popstate', () => {
                // If we're on the search page, let's try to update results without reload if possible
                const newParams = new URLSearchParams(window.location.search);
                this.searchQuery = newParams.get('q') || '';
                this.updateResults(false); // don't push state again
            });

            this.$watch('searchQuery', (value) => {
                if (this.debounceTimer) clearTimeout(this.debounceTimer);
                if (value.trim() === '') {
                    this.updateResults();
                    return;
                }
                this.debounceTimer = setTimeout(() => this.updateResults(), 400);
            });

            this.nextPageUrl = document.getElementById('ProductGridContainer')?.dataset?.nextUrl || null;
            this.initInfiniteScroll();
        },

        async updateResults(pushState = true) {
            this.loading = true;

            // Close mobile filters if they are open
            if (this.showMobileFilters) {
                this.showMobileFilters = false;
            }

            const isSearchPage = window.location.pathname.startsWith('/search');
            const isCollectionPage = window.location.pathname.includes('/collections/');

            const cleanQuery = this.searchQuery.trim();

            // Use a Map to deduplicate parameters by name (ensures mobile/desktop duplicates don't conflict)
            const paramsMap = new Map();
            let selectedCollectionUrl = null;

            // Handle Query
            if (cleanQuery) {
                paramsMap.set('q', cleanQuery);
            }

            // Handle Type
            if (isSearchPage || (!isCollectionPage && cleanQuery)) {
                paramsMap.set('type', 'product');
            }

            // Handle Filters (Collection Only)
            if (isCollectionPage) {
                const form = document.getElementById('CollectionFiltersForm');
                if (form) {
                    const formData = new FormData(form);
                    // Use entries() to handle multi-value params if needed, 
                    // but for price min/max we want the last one encountered (which will be mobile if it was interacted with)
                    for (const [key, value] of formData.entries()) {
                        if (!value || key === 'q') continue;
                        
                        // Handle price and sort_by as single values (last one wins for deduplication)
                        if (key.includes('price') || key === 'sort_by') {
                            paramsMap.set(key, value);
                        } else {
                            // Everything else can be multi-value
                            if (!paramsMap.has(key)) {
                                paramsMap.set(key, []);
                            }
                            paramsMap.get(key).push(value);
                        }
                    }
                }
            }

            const ajaxParams = new URLSearchParams();
            paramsMap.forEach((value, key) => {
                if (Array.isArray(value)) {
                    value.forEach(v => ajaxParams.append(key, v));
                } else {
                    ajaxParams.append(key, value);
                }
            });

            const fetchUrl = isSearchPage ? '/search' : (isCollectionPage ? window.location.pathname : '/search');
            const ajaxUrl = `${fetchUrl}${ajaxParams.toString() ? '?' + ajaxParams.toString() : ''}`;

            console.log(`[Search] Fetching results: ${ajaxUrl}`);

            try {
                const res = await fetch(ajaxUrl);
                if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

                const htmlText = await res.text();
                const parser = new DOMParser();
                const doc = parser.parseFromString(htmlText, 'text/html');

                // Update Grid
                const newGrid = doc.getElementById('ProductGridContainer');
                const currentGrid = document.getElementById('ProductGridContainer');
                if (newGrid && currentGrid) {
                    currentGrid.innerHTML = newGrid.innerHTML;
                }

                // Update Title
                const newTitle = doc.getElementById('CollectionTitle');
                const currentTitle = document.getElementById('CollectionTitle');
                if (newTitle && currentTitle) {
                    currentTitle.innerHTML = newTitle.innerHTML;
                }

                // Update Count
                const newCount = doc.getElementById('ProductCount');
                const currentCount = document.getElementById('ProductCount');
                if (newCount && currentCount) {
                    currentCount.innerHTML = newCount.innerHTML;
                }

                // Update Sidebar (to sync checkbox states and available faceted filters)
                const newSidebar = doc.getElementById('FilterSidebarContent');
                const currentSidebar = document.getElementById('FilterSidebarContent');
                if (newSidebar && currentSidebar) {
                    currentSidebar.innerHTML = newSidebar.innerHTML;
                }

                // Update URL
                if (pushState) {
                    window.history.pushState({ searchQuery: cleanQuery }, '', ajaxUrl);
                }

                // Update next page URL from the new content
                const nextData = doc.getElementById('next-page-data');
                this.nextPageUrl = nextData ? nextData.dataset.nextUrl : null;
                console.log('[InfiniteScroll] Updated URL:', this.nextPageUrl);

                this.initInfiniteScroll();


            } catch (e) {
                console.error('Search update failed', e);
            } finally {
                this.loading = false;
            }
        },

        clearFilters() {
            window.location.href = window.location.pathname;
        },

        // Infinite Scroll Logic
        nextPageUrl: null,
        loadingMore: false,
        observer: null,

        initInfiniteScroll() {
            if (this.observer) this.observer.disconnect();

            // Find valid next page URL if checking from DOM directly (initial load)
            if (!this.nextPageUrl) {
                const nextData = document.getElementById('next-page-data');
                this.nextPageUrl = nextData ? nextData.dataset.nextUrl : null;
            }

            console.log('[InfiniteScroll] Init. Next URL:', this.nextPageUrl);

            const sentinel = document.getElementById('infinite-scroll-sentinel');
            if (!sentinel) return;

            this.observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting && this.nextPageUrl && !this.loadingMore && !this.loading) {
                        this.loadMore();
                    }
                });
            }, { rootMargin: '400px' });

            this.observer.observe(sentinel);
        },

        async loadMore() {
            if (!this.nextPageUrl || this.loadingMore) return;

            this.loadingMore = true;
            console.log('Loading more from:', this.nextPageUrl);

            try {
                const res = await fetch(this.nextPageUrl);
                if (!res.ok) throw new Error('Failed to load more products');

                const text = await res.text();
                const parser = new DOMParser();
                const doc = parser.parseFromString(text, 'text/html');

                const newProducts = doc.querySelectorAll('#ProductGridContainer .grid > div');
                const grid = document.querySelector('#ProductGridContainer .grid');

                if (newProducts.length && grid) {
                    newProducts.forEach(product => {
                        grid.appendChild(product);
                    });
                }

                // Update next page URL
                const nextData = doc.getElementById('next-page-data');
                this.nextPageUrl = nextData ? nextData.dataset.nextUrl : null;
                console.log('[InfiniteScroll] New Next URL:', this.nextPageUrl);

            } catch (e) {
                console.error('Infinite scroll error:', e);
            } finally {
                this.loadingMore = false;
            }
        }
    }));
});

